module.exports = "/assets/dist/images/Walmart_logo.png?18a6696ff4b79599242e924f28f1aa66";